module.exports = __webpack_public_path__ + "img/person.342bb101.png";